var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3778 32.3784H26.7474V23.5608C26.7474 21.4581 26.7099 18.7513 23.819 18.7513C20.8865 18.7513 20.4378 21.0423 20.4378 23.4077V32.3778H14.8074V14.2452H20.2126V16.7232H20.2883C21.3904 14.8387 23.4397 13.7131 25.6213 13.7941C31.328 13.7941 32.3801 17.5478 32.3801 22.4311L32.3778 32.3784ZM8.45441 11.7665C6.64988 11.7669 5.18675 10.3042 5.18643 8.49966C5.18611 6.69509 6.64871 5.23193 8.45324 5.23161C10.2578 5.23128 11.7209 6.69392 11.7212 8.49849C11.7214 9.36508 11.3773 10.1962 10.7646 10.8091C10.152 11.422 9.32098 11.7664 8.45441 11.7665ZM11.2696 32.3784H5.63334V14.2452H11.2696V32.3784ZM35.1848 0.00283349H2.80406C1.27368 -0.0144372 0.0186775 1.21146 0 2.74185V35.2576C0.018038 36.7887 1.27294 38.0158 2.80406 37.9998H35.1848C36.7189 38.0188 37.9788 36.7918 38 35.2576V2.73951C37.9781 1.20609 36.7182 -0.0197365 35.1848 0.000240747",
    fill: "#0A66C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.d783a0730b2c394cb154f1067fef49fc.svg";
export { ForwardRef as ReactComponent };